// SPA discovery for DEM packs. The on-device layout is mirrored on the
// app-server: `dem/<id>/manifest.json` and `dem/<id>/<pack>.pmtiles` live under
// `<dataDir>/updates/content/`, served at `/tiles/dem/...`. The pack list isn't
// browseable through the static handler, so the app-server exposes a small
// directory index at `/tiles/dem/index.json`.

import { startTileServer } from "../webgl-maplibre/webgl-maplibre.tile-protocol";

async function tileBase(): Promise<string> {
  // Share the same baseUrl source of truth as `dem-packs.loadPack`'s
  // `archiveUrl` construction. If `startTileServer()` ever changes (e.g. a
  // path-prefixed mount), discovery and archive fetches move in lockstep.
  return (await startTileServer()).replace(/\/$/, "");
}

export async function listPackIds(): Promise<string[]> {
  let url = "";
  try {
    url = `${await tileBase()}/dem/index.json`;
    const r = await fetch(url, { cache: "no-store" });
    if (!r.ok) {
      console.warn(`dem-fs: GET ${url} → ${r.status}; treating as no packs installed`);
      return [];
    }
    const body = (await r.json()) as { packs?: unknown };
    if (!Array.isArray(body.packs)) return [];
    return body.packs.filter((x): x is string => typeof x === "string");
  } catch (err) {
    console.warn(`dem-fs: GET ${url || "/dem/index.json"} threw`, err);
    return [];
  }
}

export async function readPackManifest(packId: string): Promise<string | null> {
  let url = "";
  try {
    url = `${await tileBase()}/dem/${encodeURIComponent(packId)}/manifest.json`;
    const r = await fetch(url, { cache: "no-store" });
    if (!r.ok) {
      console.warn(`dem-fs: GET ${url} → ${r.status}`);
      return null;
    }
    return await r.text();
  } catch (err) {
    console.warn(`dem-fs: GET ${url || `/dem/${packId}/manifest.json`} threw`, err);
    return null;
  }
}
